const PIXEL_ID = '1666572947695847'

let initialized = false

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  try {
    const f: any = window
    const b = document
    const v = 'https://connect.facebook.net/en_US/fbevents.js'

    if (f.fbq) return

    const n: any = function (...args: unknown[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args)
      } else {
        n.queue.push(args)
      }
    }
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = [] as unknown[][]

    f.fbq = n
    if (!f._fbq) f._fbq = n

    const t = b.createElement('script') as HTMLScriptElement
    t.async = true
    t.src = v
    t.onload = () => {
      console.log('[MetaPixel] Script loaded successfully')
    }
    t.onerror = () => {
      console.warn(
        '[MetaPixel] Script failed to load — may be blocked by ad blocker',
      )
    }
    const s = b.getElementsByTagName('script')[0]
    if (s?.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }

    f.fbq('init', PIXEL_ID)
    console.log('[MetaPixel] Initialized with ID:', PIXEL_ID)

    // Add noscript fallback image
    const noscript = b.createElement('img')
    noscript.height = 1
    noscript.width = 1
    noscript.style.display = 'none'
    noscript.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    b.body.appendChild(noscript)
  } catch (err) {
    console.error('[MetaPixel] Init error:', err)
  }
}

export function trackPageView() {
  try {
    if (window.fbq) {
      window.fbq('track', 'PageView')
      console.log('[MetaPixel] Tracked: PageView')
    } else {
      console.warn('[MetaPixel] fbq not available for PageView')
    }
  } catch (err) {
    console.error('[MetaPixel] PageView error:', err)
  }
}

export function trackAddToCart() {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Sistema Mamá IA',
        content_type: 'product',
        value: 6.36,
        currency: 'USD',
      })
      console.log('[MetaPixel] Tracked: AddToCart')
    } else {
      console.warn('[MetaPixel] fbq not available for AddToCart')
    }
  } catch (err) {
    console.error('[MetaPixel] AddToCart error:', err)
  }
}
